import campaignActionSharedState from '../../../campaign-action-shared/store/state'

export default {
  ...campaignActionSharedState,

  event: {
    shifts: [],
    slug: null
  },

  eventStatus: {
    allowWaitlistSignup: null,
    cancelled: false,
    currentUserIsHost: false,
    full: false,
    hiddenAddress: false,
    publiclyVisible: true,
    sharingDisabled: false
  },

  // This reflects the status as persisted on the server
  attendingStatus: null,
  attendingShiftIds: [],

  // Post-submission: Reveal location (if applicable)
  locationRevealed: false,
  fullLocationHtml: null,

  // Post-submission and later: Update attending status
  editingAttendingShifts: false,
  updateAttendeeUrl: null,
  showConfirmNotAttendingModal: false,

  // Post-submission: show the web conference link (if applicable)
  webConferenceLinkRevealed: false,
  webConferenceLinkHtml: null
}
